// AddCardForm.jsx
import {
  CardNumberElement,
  CardExpiryElement,
  CardCvcElement,
  useStripe,
  useElements,
} from "@stripe/react-stripe-js";
import { useLoginData } from "component/common/loginData";
import Button from "component/ui/Button";
import FullPageLoader from "component/ui/fullPageLoader";
import Input from "component/ui/Input";
import { getCountryCode } from "helper/appConstant";
import { CARD_BRAND_LABELS } from "helper/constant";
import { useState } from "react";
import { useDispatch } from "react-redux";
import { addPaymentCards } from "store/slice/booking";

const OPTIONS = {
  style: {
    base: {
      fontSize: "15px",
      color: "#111827",
      fontFamily: "Inter, sans-serif",
      "::placeholder": { color: "#9ca3af" },
    },
    invalid: { color: "#ef4444" },
  },
};

export default function AddCardForm({
  fetchCardsList,
  setShowAddCard,
  setLoader,
  loader,
}) {
  const stripe = useStripe();
  const elements = useElements();
  const userData=useLoginData()
  const [error, setError] = useState(null);
  const [name, setName] = useState(userData?.name);
  const dispatch = useDispatch();
  const handleSuccess = (status) => {
    if (status) {
      fetchCardsList();
      setShowAddCard(false);
    }
    setLoader(false);
  };
  const handleAddCard = async (data) => {
    let request = {
      language: "en",
      paymentMethodId: data?.id,
      cardNumber: data?.card?.last4,
      cardType: data?.card?.funding,
      cardBrand: CARD_BRAND_LABELS[data?.card?.brand] ?? "Card",
      cardHolderName: name,
      country: data?.card?.country,
      locationCountry: await getCountryCode(userData),
      zipcode: "",
      isCardPrimary: false,
    };
    dispatch(addPaymentCards(request, handleSuccess));
  };
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!name) {
      setError("Please enter name");
      return;
    }
    if (!stripe || !elements) return;
    setLoader(true);
    const card = elements.getElement(CardNumberElement);

    const { error, paymentMethod } = await stripe.createPaymentMethod({
      type: "card",
      card,
    });

    if (error) {
      setError(error.message);
      setLoader(false);
    } else handleAddCard(paymentMethod);
  };
  const handleChange = (event) => {
    if (error) {
      setError(null);
    }

    // Optional: show live Stripe validation error
    if (event.error) {
      setError(event.error.message);
    }
  };
  return (
    <form onSubmit={handleSubmit}>
      {loader && <FullPageLoader />}
      <div className="mb-3">
        <Input
          value={name}
          onChange={(value) => {
            setName(value);
            setError("");
          }}
          placeholder={"Enter Full Name"}
        />
      </div>
      <div className="input-box pt-3">
        <CardNumberElement options={OPTIONS} onChange={handleChange} />
      </div>

      <div className="row">
        <div className="input-box">
          <CardExpiryElement options={OPTIONS} onChange={handleChange} />
        </div>
        <div className="input-box">
          <CardCvcElement options={OPTIONS} onChange={handleChange} />
        </div>
      </div>

      {error && <p className="error">{error}</p>}

      <Button fullWidth className={"mt-4"}>
        Add Card
      </Button>

      <style>{`
        .input-box {
          padding: 12px;
          border: 1px solid #e5e7eb;
          border-radius: 8px;
          background: white;
        }

        .row {
          display: flex;
          gap: 12px;
          margin-top: 12px;
        }

        .row .input-box {
          flex: 1;
        }

        .error {
          color: #ef4444;
          margin-top: 8px;
        }

        .btn {
          margin-top: 16px;
          padding: 10px 16px;
          background: #4f46e5;
          color: white;
          border: none;
          border-radius: 6px;
          cursor: pointer;
        }
      `}</style>
    </form>
  );
}
